import type { Theme } from '@emotion/react';
import styled from '@emotion/styled';

import { mq, shouldForwardProp } from '@hrworks/design-system/utilities';

import type { CardProps } from './Card.types';

const componentConfig = (theme: Theme) => ({
  padding: theme.eclipseTier1.spacing['24px'],
});

const Container = styled('div', {
  shouldForwardProp: (prop) => prop !== 'as' && shouldForwardProp(prop),
})<{
  $fullHeight?: CardProps['fullHeight'];
  $isInteractive?: CardProps['isInteractive'];
}>(({ theme, onClick, $fullHeight, $isInteractive }) => {
  const border = `1px solid ${theme.eclipseTier2Color.border.bold}`;

  return {
    backgroundColor: theme.eclipseTier2Color.surface.raised,
    border,
    borderRadius: theme.eclipseTier1.radius['8px'],
    '> :not(:last-child)': {
      borderBottom: border,
    },
    ...((onClick || $isInteractive) && {
      cursor: 'pointer',
      [mq.supportsHover]: {
        ':hover': {
          borderColor: theme.eclipseTier2Color.border.selected,
        },
      },
    }),
    ...($fullHeight && {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    }),
  };
});

export const S = {
  componentConfig,
  Container,
} as const;
